var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-wrap",attrs:{"df":"","fw":"","fdc":""},on:{"click":_vm.onDetail}},[_c('div',{staticClass:"card-subject"},[_vm._v(_vm._s(_vm.card.subject))])])}
var staticRenderFns = []

export { render, staticRenderFns }